import React, { useContext } from 'react'
import PermanenceReportContext from '../../../context/PermanenceReportContext/PermanenceReportContext';
import PermanenceDetail from './PermanenceDetail';
import { t } from 'i18next';
import { EmptyStateOne } from '../../Empty/EmptyStateOne';

const PermanenceDetailList = () => {
    const { permanenceReportState } = useContext(PermanenceReportContext);
    const { reports } = permanenceReportState;

    return (
        <div>
            <div
                className='d-flex flex-column gap-1 no-show-scroll'
                style={{ maxHeight: '430px', overflowY: 'auto' }}
            >
                {reports.length === 0 && (<EmptyStateOne message={t('NO_DATA_SEARCH')} />)}
                {reports.map((report, idx) =>
                    <PermanenceDetail key={idx} report={report} />
                )}
            </div>
        </div>
    )
}

export default PermanenceDetailList